// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1Neo4jClusterStatus } from './V1Neo4jClusterStatus';
import {
  V1Neo4jClusterStatusFromJSON,
  V1Neo4jClusterStatusFromJSONTyped,
  V1Neo4jClusterStatusToJSON,
  V1Neo4jClusterStatusToJSONTyped,
} from './V1Neo4jClusterStatus';
import type { V1ObjectMeta } from './V1ObjectMeta';
import {
  V1ObjectMetaFromJSON,
  V1ObjectMetaFromJSONTyped,
  V1ObjectMetaToJSON,
  V1ObjectMetaToJSONTyped,
} from './V1ObjectMeta';
import type { V1Neo4jClusterInternalState } from './V1Neo4jClusterInternalState';
import {
  V1Neo4jClusterInternalStateFromJSON,
  V1Neo4jClusterInternalStateFromJSONTyped,
  V1Neo4jClusterInternalStateToJSON,
  V1Neo4jClusterInternalStateToJSONTyped,
} from './V1Neo4jClusterInternalState';
import type { V1SourceBackup } from './V1SourceBackup';
import {
  V1SourceBackupFromJSON,
  V1SourceBackupFromJSONTyped,
  V1SourceBackupToJSON,
  V1SourceBackupToJSONTyped,
} from './V1SourceBackup';
import type { V1Neo4jClusterSpec } from './V1Neo4jClusterSpec';
import {
  V1Neo4jClusterSpecFromJSON,
  V1Neo4jClusterSpecFromJSONTyped,
  V1Neo4jClusterSpecToJSON,
  V1Neo4jClusterSpecToJSONTyped,
} from './V1Neo4jClusterSpec';

/**
 *
 * @export
 * @interface V1Neo4jCluster
 */
export interface V1Neo4jCluster {
  /**
   * APIVersion defines the versioned schema of this representation of an object.
   * Servers should convert recognized schemas to the latest internal value, and
   * may reject unrecognized values.
   * More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#resources
   * +optional
   * @type {string}
   * @memberof V1Neo4jCluster
   */
  apiVersion?: string;
  /**
   * Deprecated: we need to get rid of this - we can't expect cluster to be tied to a specific dbid
   * @type {string}
   * @memberof V1Neo4jCluster
   */
  dbid?: string;
  /**
   *
   * @type {V1Neo4jClusterInternalState}
   * @memberof V1Neo4jCluster
   */
  internalState?: V1Neo4jClusterInternalState;
  /**
   * Kind is a string value representing the REST resource this object represents.
   * Servers may infer this from the endpoint the client submits requests to.
   * Cannot be updated.
   * In CamelCase.
   * More info: https://git.k8s.io/community/contributors/devel/sig-architecture/api-conventions.md#types-kinds
   * +optional
   * @type {string}
   * @memberof V1Neo4jCluster
   */
  kind?: string;
  /**
   *
   * @type {V1ObjectMeta}
   * @memberof V1Neo4jCluster
   */
  metadata?: V1ObjectMeta;
  /**
   *
   * @type {V1SourceBackup}
   * @memberof V1Neo4jCluster
   */
  originBackup?: V1SourceBackup;
  /**
   *
   * @type {V1Neo4jClusterSpec}
   * @memberof V1Neo4jCluster
   */
  spec?: V1Neo4jClusterSpec;
  /**
   *
   * @type {V1Neo4jClusterStatus}
   * @memberof V1Neo4jCluster
   */
  status?: V1Neo4jClusterStatus;
}

/**
 * Check if a given object implements the V1Neo4jCluster interface.
 */
export function instanceOfV1Neo4jCluster(
  value: object,
): value is V1Neo4jCluster {
  return true;
}

export function V1Neo4jClusterFromJSON(json: any): V1Neo4jCluster {
  return V1Neo4jClusterFromJSONTyped(json, false);
}

export function V1Neo4jClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Neo4jCluster {
  if (json == null) {
    return json;
  }
  return {
    apiVersion: json['apiVersion'] == null ? undefined : json['apiVersion'],
    dbid: json['dbid'] == null ? undefined : json['dbid'],
    internalState:
      json['internalState'] == null
        ? undefined
        : V1Neo4jClusterInternalStateFromJSON(json['internalState']),
    kind: json['kind'] == null ? undefined : json['kind'],
    metadata:
      json['metadata'] == null
        ? undefined
        : V1ObjectMetaFromJSON(json['metadata']),
    originBackup:
      json['originBackup'] == null
        ? undefined
        : V1SourceBackupFromJSON(json['originBackup']),
    spec:
      json['spec'] == null
        ? undefined
        : V1Neo4jClusterSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : V1Neo4jClusterStatusFromJSON(json['status']),
  };
}

export function V1Neo4jClusterToJSON(json: any): V1Neo4jCluster {
  return V1Neo4jClusterToJSONTyped(json, false);
}

export function V1Neo4jClusterToJSONTyped(
  value?: V1Neo4jCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiVersion: value['apiVersion'],
    dbid: value['dbid'],
    internalState: V1Neo4jClusterInternalStateToJSON(value['internalState']),
    kind: value['kind'],
    metadata: V1ObjectMetaToJSON(value['metadata']),
    originBackup: V1SourceBackupToJSON(value['originBackup']),
    spec: V1Neo4jClusterSpecToJSON(value['spec']),
    status: V1Neo4jClusterStatusToJSON(value['status']),
  };
}
